import { AcCapitalize, AcIsSet, VISUALS } from "ui-kit";

export const AcFormatPaymentMethod = (t, payment_method) => {
  switch (payment_method) {
    case "paypal":
    case "paypal-pc":
    case "paypal-ppcp":
      return "PayPal";

    case "ideal":
      return "iDEAL";

    case "in3":
      return "in3";

    case "twint":
      return "Twint";

    case "sepa":
      return "Bank Transfer";

    case "sofort":
    case "sofort-banking":
      return "Sofortüberweisung";

    case "mybank":
      return "MyBank";

    case "bcmc":
      return "Bancontact";

    case "pi-single":
      return "Pay by bank";

    case "apple-pay":
      return "Apple Pay";

    case "google-pay":
      return "Google Pay";

    case "paysafecard":
      return "PaysafeCard";

    case "creditcard":
      return t("payment-methods.creditcard", "Creditcard", { ns: "common" });

    case "mandate":
      return t("payment-methods.mandate", "Mandate", { ns: "common" });

    case "multi":
      return t("payment-methods.multi", "Multi", { ns: "common" });

    default:
      return AcCapitalize(payment_method);
  }
};

export const AcGetPaymentMethodIcon = (payment_method) => {
  switch (payment_method) {
    case "bcmc":
      return VISUALS.PAYMENT_METHODS.BANCONTACT;

    case "creditcard":
      return VISUALS.PAYMENT_METHODS.CREDITCARD;

    case "in3":
      return VISUALS.PAYMENT_METHODS.IN3;

    case "twint":
      return VISUALS.PAYMENT_METHODS.TWINT;

    case "giropay":
      return VISUALS.PAYMENT_METHODS.GIROPAY;

    case "ideal":
      return VISUALS.PAYMENT_METHODS.IDEAL;

    case "klarna":
    case "sofort":
    case "sofort-banking":
      return VISUALS.PAYMENT_METHODS.KLARNA_FILLED;

    case "multi":
      return VISUALS.PAYMENT_METHODS.MULTI;

    case "mybank":
      return VISUALS.PAYMENT_METHODS.MYBANK;

    case "paypal":
    case "paypal-pc":
    case "paypal-ppcp":
      return VISUALS.PAYMENT_METHODS.PAYPAL_BRAND;

    case "sepa":
      return VISUALS.PAYMENT_METHODS.SEPA_BRAND;

    case "mandate":
      return VISUALS.PAYMENT_METHODS.MANDATE;

    case "pi-single":
      return VISUALS.PAYMENT_METHODS.PI;

    case "apple-pay":
      return VISUALS.PAYMENT_METHODS.APPLE_PAY;

    case "google-pay":
      return VISUALS.PAYMENT_METHODS.GOOGLE_PAY;

    case "paysafecard":
      return VISUALS.PAYMENT_METHODS.PAYSAFECARD;

    default:
  }
};

export const AcGetPaymentMethodImg = (
  t,
  classes,
  payment_method,
  parent_payment_method
) => {
  let Icon = null;
  let paymentMethodFormatted = "";

  if (parent_payment_method !== null) {
    Icon = AcGetPaymentMethodIcon(parent_payment_method);
    paymentMethodFormatted =
      "Multi - " + AcFormatPaymentMethod(t, parent_payment_method);
  } else {
    Icon = AcGetPaymentMethodIcon(payment_method);
    paymentMethodFormatted = AcFormatPaymentMethod(t, payment_method);
  }

  if (!AcIsSet(Icon)) {
    return null;
  }

  return (
    <img
      src={Icon}
      style={payment_method === "google-pay" ? { maxWidth: "initial" } : null}
      className={classes}
      title={`${t("payment-method", "Payment method", {
        ns: "common",
      })}: ${paymentMethodFormatted}`}
      alt={`${t("payment-method", "Payment method", {
        ns: "common",
      })}: ${paymentMethodFormatted}`}
      rel={paymentMethodFormatted}
    />
  );
};

export default {
  AcFormatPaymentMethod: AcFormatPaymentMethod,
  AcGetPaymentMethodIcon: AcGetPaymentMethodIcon,
  AcGetPaymentMethodImg: AcGetPaymentMethodImg,
};
